module.exports = __webpack_public_path__ + "img/mC-power-6.8c8bde4f.png";